import React, { Fragment, useEffect, useRef } from "react";
import {
  CssBaseline,
  withWidth,
  Menu,
  MenuItem,
  Typography,
  withStyles
} from "@material-ui/core";
import Headline from "./headline";
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AuthActions } from "../../../../modules/redux";
import { dashboardStyles } from "../../../../styles";
import { AuthState, UserData } from "../../../../modules/redux/Auth/reducer";
import Content from "./content";
import { CurrentState, GetChannelResource } from "../../../../const";
import { GRAPH_REQUESTS, msalApp } from "../../../Authentication/auth-utils";
import { UserService } from "../../../User/actions";
import { RoleService } from "../../../Role/actions";
import { InteractionRequiredAuthError } from "msal";
import LoginRedirect from "./LoginRedirect";
import { RequestTrialService } from "../../action";

import LandingPageLogo from "./assets/landingPage/Logo.svg";

import HighEfficiency from "./assets/landingPage/IconsDifference/efficiency.svg";
import MarketAgility from "./assets/landingPage/IconsDifference/marketAgility.svg";
import IncreasedProductivity from "./assets/landingPage/IconsDifference/productivityRates.svg";
import GreaterSustainability from "./assets/landingPage/IconsDifference/sustainability.svg";
import CostOptimization from "./assets/landingPage/IconsDifference/investment.svg";
import DeepDomainExpertise from "./assets/landingPage/IconsDifference/domainExpert.svg";

import ResearchIcon from "./assets/landingPage/researchIcon.svg";
import academyIcon from "./assets/landingPage/academyIcon.svg";
import hpcIcon from "./assets/landingPage/hpcIcon.svg";
import Knowledge from "../../../../assert/images/landingPage/Competencies/knowledge.png";
import IndustrialKnowledge from "../../../../assert/images/landingPage/Competencies/industrialKnow.png";
import Outcome from "../../../../assert/images/landingPage/Competencies/outcome.png";

import Blueprint from "./assets/landingPage/IconsCapabilities/Blueprint.svg";
import Centre from "./assets/landingPage/IconsCapabilities/Centre.svg";
import Identity from "./assets/landingPage/IconsCapabilities/Identity.svg";
import Money from "./assets/landingPage/IconsCapabilities/Money.svg";

import Hybrid from "./assets/landingPage/Hybrid_cloud.svg";
import IoT from "./assets/landingPage/Edge_IOT.svg";
import Private from "./assets/landingPage/Private_cloud.svg";
import Public from "./assets/landingPage/Public_cloud.svg";

import { Box, Grid, Container } from "@mui/material";
import Research from "./Research";
import HPCComponent from "./HPC";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import homeStyles from "./HomeStyles.module.css";
import generalStyles from "./assets/css/general.module.css";

const banner = [
  {
    title: "Your Cloud. <span>Simplified</span>",
    paragraph: "You don’t have to know the cloud to use the cloud.",
    subTitle: "What is <span>ManageX?</span>",
    content: [
      "ManageX is a <span>cloud infrastructure abstraction layer</span> that  empowers non-IT aligned researchers, staff, employees, and students with direct access to limitless computing resources at a global scale. All with cost controls, security, and compliance built in.",
      "ManageX enables <span>simpler, more intuitive cloud utilization scenarios</span> with collaboration supported across legacy databases,  application runtime environments, and large-scale compute clusters. All through an intuitive and productive experience"
    ]
  }
];



const whyUs = [
  {
    image: HighEfficiency,
    content:
      "Faster operational cycle times lead to <b>increased efficiencies</b>",
    highlight: "Higher Efficiency"
  },
  {
    image: MarketAgility,
    content:
      "Accelerated time-to decision empowers <b>greater market agility</b>",
    highlight: "Market Agility"
  },
  {
    image: IncreasedProductivity,
    content:
      "Highly optimized application run-time environments yields <b>higher productivity rates</b>",
    highlight: "Increased Productivity"
  },
  {
    image: GreaterSustainability,
    content:
      "A reduced IT carbon footprint enables <b>greater sustainability</b>",
    highlight: "Greater Sustainability"
  },
  {
    image: CostOptimization,
    content:
      "Nimble infrastructure scaling delivers an optimum <b>value for investment</b>",
    highlight: "Cost Optimization"
  },
  {
    image: DeepDomainExpertise,
    content:
      "Confidence across cloud, edge, and hybrid with <b>ubiquitous domain expertise</b>",
    highlight: "Deep Domain Expertise"
  }
];

const solution = [
  {
    resource: "ManageX",
    title: "Research",
    image: ResearchIcon,
    url: window.location.origin + "/research",
    paragraph:
      "Bring the speed, scale, and security of the cloud directly into your academic research workflow…without changing what you do or how you do it."
  },
  {
    resource: "ManageX",
    title: "Academy",
    image: academyIcon,
    url: "https://managex.academy",
    paragraph:
      "Build your knowledge base & working experience of game-changing cloud services that can improve productivities and efficiencies for any application."
  },
  {
    resource: "ManageX",
    title: "HPC",
    image: hpcIcon,
    url: window.location.origin + "/hpc/i",
    paragraph:
      "Get all the advantages of HPC without the cost of development, deployment, use, and management with ManageX - your HPC solution in the cloud."
  }
];

const competencies = [
  {
    image: Knowledge,
    title: "Knowledge Depth & Breadth",
    desc: "Decades of executive, logical, and operational brain trust with emerging & disruptive global technology platforms"
  },
  {
    image: IndustrialKnowledge,
    title: "Relevant Industrial Know-How",
    desc: "Extensive backgrounds spent deep within the same industrial verticals that align with Terawe solution platforms"
  },
  {
    image: Outcome,
    title: "Outcomes, Not Technologies",
    desc: "Our focus is identifying and delivering the most beneficial outcomes for our clients through technologies."
  }
];

const capabilities = [
  {
    image: Identity,
    title: "Identity Management",
    tag: "Seamless single sign on experience"
  },
  {
    image: Centre,
    title: "Centralized IT Deployment",
    tag: "One-click provisioning for multiple assets"
  },
  {
    image: Blueprint,
    title: "Blueprints & Templates",
    tag: "Out-of-the-box integration maps for third parties"
  },
  {
    image: Money,
    title: "Cost Management Control",
    tag: "Centralized payments & reconciliation"
  }
];

const resources = [
  {
    image: Private,
    title: "Private Clouds"
  },
  {
    image: Public,
    title: "Public Clouds"
  },
  {
    image: Hybrid,
    title: "Hybrid Clouds"
  },
  {
    image: IoT,
    title: "Edge/IoT"
  }
];

const pages = [
  {
    label: "Home"
  },
  {
    label: "Our Differences"
  },
  {
    label: "Solutions",
    subMenu: [
      {
        label: "Academy",
        url: "https://managex.academy"
      },
      {
        label: "Research",
        url: window.location.origin + "/research"
      },
      {
        label: "HPC",
        url: window.location.origin + "/hpc/i"
      }
    ]
  },
  {
    label: "Capabilities"
  },
  {
    label: "Contact Sales"
  }
];
const ColorButton = styled(Button)(({ theme }) => ({
  fontFamily: "inherit"
}));
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right"
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right"
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: "#000000",
    color: "#ffffff",
    marginTop: "51px",
    "& .MuiMenuItem-root": {
      justifyContent: "center"
    }
  }
}));

const CopyRightContainer = withStyles((theme) => ({
  root : {
    width : '100%',
    display :'flex',
    justifyContent : "start",
    [theme.breakpoints.down("md")]: {
      justifyContent : "center"
    }
    // theme.breakpoints.up
  }
}))(({classes, children}) => {
  return <div className={classes.root}>{children}</div>
})

function ManageX(props) {
  const dispatch = useDispatch();
  const classes = dashboardStyles();
  const auth = useSelector((state) => state.auth);
  const appSettings = useSelector((state) => state.appSettings);
  const [loginErrorMessage, setLoginErrorMessage] = React.useState("");
  const [selectTab, setSelectTab] = React.useState("home");
  const [loginRequestStatus, setLoginRequestStatus] = React.useState(false);
  const [requestTrialLoading, setRequestTrialLoading] = React.useState(false);
  const [showRequestTrailMessage, setShowRequestTrialMessage] =
    React.useState(false);
  const [disableError, setDisableError] = React.useState(false);
  const [contactErrorMessage, setContactErrorMessage] = React.useState("");
  const [signInClick, setSignInClick] = React.useState(false);
  const [requestTrialData, setRequestTrialData] = React.useState({
    name: "",
    email: "",
    org: "",
    industryType: "",
    jobTitle: "",
    purpose: "",
    mobile: "",
    country: "",
    lastname: "",
    firstname: ""
  });
  const [error, setError] = React.useState(false);
  const [emailError, setEmailError] = React.useState(false);
  const [contactError, setContactError] = React.useState(false);
  const [pathUrl, setPathUrl] = React.useState(window.location.pathname);
  const [channelResource, setChannelResource] = React.useState([]);

  const offerRef = useRef();
  const capabilitiesRef = useRef();
  const eliminateRef = useRef();
  const resourceRef = useRef();
  const requestTrial = useRef();
  const benefitRef = useRef();

  // New Design Reference
  const homeRef = useRef();
  const WhysUsRef = useRef();
  const SolutionsRef = useRef();
  const TestimonialRef = useRef();
  const contactRef = useRef();
  const year = new Date().getFullYear();

  const [value, setValue] = React.useState(0);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (index, e) => {
    setAnchorEl({ [index]: e.currentTarget });
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  function RequestTrialAccess() {
    if (
      !emailError ||
      !contactError ||
      requestTrialData.firstname === "" ||
      requestTrialData.country === "" ||
      requestTrialData.mobile === "" ||
      requestTrialData.jobTitle === "" ||
      requestTrialData.industryType === "" ||
      requestTrialData.org === "" ||
      requestTrialData.lastname === "" ||
      requestTrialData.email === "" ||
      requestTrialData.purpose === ""
    ) {
      setError(true);
    } else {
      setError(false);
      let params = { ...requestTrialData };

      setRequestTrialLoading(true);

      params["name"] = params.lastname + " " + params.firstname;

      RequestTrialService.Request(params)
        .then((res) => {
          setDisableError(false);
          setShowRequestTrialMessage(true);
          setLoginRequestStatus(res.data.success);
          setLoginErrorMessage(res.data.message);
          setRequestTrialLoading(false);
          window.scrollTo(0, 0);
        })
        .catch((_) => {
          setDisableError(false);
          setLoginRequestStatus(false);
          setShowRequestTrialMessage(true);
          setLoginErrorMessage("Error in the Submission");
          setRequestTrialLoading(false);
          window.scrollTo(0, 0);
        });
    }
  }

  const MENU_ITEMS = {
    HOME: "home",
    WHY_US: "why_us",
    SOLUTIONS: "solutions",
    TESTIMONIALS: "testimonials",
    CONTACT_US: "contact_us",
    CAPABILITIES: "capabilities"
  };

  function handleMenuClick(key) {
    setValue(key);
    switch (key) {
      case 0:
        homeRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case 1:
        WhysUsRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case 2:
        SolutionsRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case 3:
        capabilitiesRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case 4:
      case MENU_ITEMS.CONTACT_US:
        contactRef.current.scrollIntoView({ behavior: "smooth" });
        break;

      case "eliminate":
        eliminateRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "offer":
        offerRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "resources":
        resourceRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "requestTrail":
        requestTrial.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "testimonials":
        TestimonialRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
        homeRef.current.scrollIntoView({ behavior: "smooth" });
        break;
    }
  }

  useEffect(() => {
    document.title = `ManageX`;
  }, []);

  if (auth.state === AuthState.SWITCH_DIRECTORY) {
    dispatch(AuthActions.login(auth));
  }

  if (auth.state === AuthState.LOGIN_REQUEST) {
    setTimeout(function () {
      let currentState = CurrentState();
      if (currentState === AuthState.LOGIN_REQUEST) {
        dispatch(AuthActions.logout("Request Timeout Error(Error Code - 408)"));
      }
    }, 120000);
  }

  if (auth.state === AuthState.SET_TOKEN) {
    setTimeout(function () {
      let currentState = CurrentState();
      if (currentState === AuthState.SET_TOKEN) {
        dispatch(AuthActions.logout("Request Timeout Error(Error Code - 408)"));
      }
    }, 60000);
  }

  function authCallback(error, loginResponse) {
    const setToken = (result) => {
      return {
        type: AuthState.SET_TOKEN,
        payload: result
      };
    };
    const request = () => {
      return {
        type: AuthState.LOGIN_REQUEST
      };
    };
    const success = (result, account = UserData.account) => {
      return {
        type: AuthState.LOGGED_IN,
        payload: result,
        account: account,
        lastUrl: ""
      };
    };

    function stateUpdate(loginResponse, azureResponse) {
      function funcCallback(err, result) {
        if (err) {
          dispatch(AuthActions.logout(err.toString()));
        } else {
          loginResponse.accessToken = result.accessToken;
          loginResponse.azureToken = azureResponse.accessToken;
          loginResponse.secondaryAzureToken = azureResponse.accessToken;

          dispatch(setToken(loginResponse));

          UserService.GetLoginUserDetails(
            result.accessToken,
            azureResponse.accessToken
          )
            .then((res) => {
              if (res.data.success) {
                RoleService.GetDataByUsingKeyAndOrgKey(
                  res.data.data.role,
                  res.data.data.orgInfo.orgId,
                  result.accessToken,
                  azureResponse.accessToken
                ).then((roleResult) => {
                  if (roleResult.status !== 204) {
                    if (roleResult?.data?.status?.toLowerCase() === "active") {
                      if (res.data.data.orgInfo.isCustomSubscription) {
                        UserService.GetAzureToken().then((azureTokenResult) => {
                          res.data.data.roleInfo = roleResult.data;
                          loginResponse.secondaryAzureToken =
                            azureTokenResult.data.data;
                          dispatch(success(loginResponse, res.data.data));
                        });
                      } else {
                        res.data.data.roleInfo = roleResult.data;
                        dispatch(success(loginResponse, res.data.data));
                      }
                    } else {
                      dispatch(
                        AuthActions.logout(
                          `User role in ${roleResult.data.status} State. Please contact admin.`
                        )
                      );
                    }
                  } else {
                    dispatch(
                      AuthActions.logout(
                        `User role not found. Please contact admin.`
                      )
                    );
                  }
                });
              } else {
                dispatch(AuthActions.logout(res.data.message));
              }
            })
            .catch((err) => {
              dispatch(AuthActions.logout(err.toString()));
            });
        }
      }
      let instance = msalApp(loginResponse.tenantId, appSettings.msService);
      instance.handleRedirectCallback(funcCallback);
      instance
        .acquireTokenSilent(GRAPH_REQUESTS.PROFILE(appSettings.msService))
        .then((result) => funcCallback(null, result))
        .catch((err) => {
          if (err instanceof InteractionRequiredAuthError) {
            instance
              .acquireTokenPopup(GRAPH_REQUESTS.PROFILE(appSettings.msService))
              .then((result) => funcCallback(null, result))
              .catch((err) => funcCallback(err, null));
          } else {
            funcCallback(err, null);
          }
        });
    }

    try {
      if (loginResponse) {
        dispatch(request());
        msalApp(loginResponse.tenantId, appSettings.msService)
          .acquireTokenSilent(GRAPH_REQUESTS.AZURE_SCOPE(appSettings.msService))
          .then((azureResponse) => {
            stateUpdate(loginResponse, azureResponse);
          })
          .catch((err) => {
            if (err instanceof InteractionRequiredAuthError) {
              msalApp(loginResponse.tenantId, appSettings.msService)
                .acquireTokenPopup(
                  GRAPH_REQUESTS.AZURE_SCOPE(appSettings.msService)
                )
                .then((azureResponse) => {
                  stateUpdate(loginResponse, azureResponse);
                })
                .catch((err) => {
                  if (err instanceof InteractionRequiredAuthError) {
                    function azureAuthCallback(error, azureResponse) {
                      if (error) {
                        dispatch(AuthActions.logout(error.toString()));
                      } else {
                        stateUpdate(loginResponse, azureResponse);
                      }
                    }
                    msalApp(
                      loginResponse.tenantId,
                      appSettings.msService
                    ).handleRedirectCallback(azureAuthCallback);
                    msalApp(
                      loginResponse.tenantId,
                      appSettings.msService
                    ).acquireTokenRedirect(
                      GRAPH_REQUESTS.AZURE_SCOPE(appSettings.msService)
                    );
                  } else {
                    dispatch(AuthActions.logout(err.toString()));
                  }
                });
            } else {
              dispatch(AuthActions.logout(err.toString()));
            }
          });
      } else {
        dispatch(AuthActions.logout("Popup Canceled"));
      }
    } catch (err) {
      dispatch(AuthActions.logout(err.toString()));
    }
  }

  useEffect(() => {
    msalApp(auth.tenantId, appSettings.msService).handleRedirectCallback(
      authCallback
    );
  });

  useEffect(() => {
    setLoginErrorMessage(auth.errorMsg);
    setDisableError(false);
  }, [auth]);

  useEffect(() => {
    GetChannelResource().then((res) => {
      setChannelResource(res.data.data);
    });
  }, []);

  return (
    <React.Fragment>
      {auth.state !== AuthState.LOGGED_IN ||
      auth.state === AuthState.SWITCH_DIRECTORY ? (
        signInClick ? (
          <div>
            <LoginRedirect
              setSignInClick={setSignInClick}
              onSignIn={() => dispatch(AuthActions.login(auth))}
            />
          </div>
        ) : (
          <>
            {(() => {
              switch (pathUrl) {
                case "/":
                  return (
                    <div className={classes.mainSection}>
                      {/* navbar */}
                      <AppBar position="fixed" className={homeStyles.mainMenu}>
                        <Container maxWidth="xl">
                          <Toolbar disableGutters>
                            <Box
                              href="#app-bar-with-responsive-menu"
                              sx={{
                                display: { xs: "none", md: "flex" }
                              }}
                              className={homeStyles.logo}
                            >
                              <img
                                src={LandingPageLogo}
                                alt="Logo"
                                className={homeStyles.menuLogo}
                              />
                            </Box>
                            {/* Mobile menu */}
                            <Box
                              sx={{
                                flexGrow: 1,
                                display: { xs: "flex", md: "none" },
                                justifyContent: "start",
                                alignItems: "center"
                              }}
                            >
                              <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="default"
                                sx={{
                                  color : "#ffffff !important"
                                }}
                              >
                                <MenuIcon 
                                
                                />
                              </IconButton>
                              <img
                                src={LandingPageLogo}
                                alt="Logo"
                                height="30px" 
                                style={{
                                  width : "calc(100% - 96px)"
                                }}
                              />
                              {/* dropdown menu */}
                              <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "right"
                                }}
                                keepMounted
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right"
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                  display: { xs: "block", md: "none" },
                                  flexGrow: 0
                                }}
                              >
                                {pages.map((page, index) => (
                                  <MenuItem
                                    key={index}
                                    onClick={() => {
                                      handleMenuClick(index);
                                      handleCloseNavMenu();
                                    }}
                                  >
                                    <Typography>{page.label}</Typography>
                                  </MenuItem>
                                ))}
                              </Menu>
                            </Box>
                            {/* Desktop Menu */}
                            <Box
                              sx={{
                                marginLeft: "auto",
                                display: { xs: "none", md: "flex" }
                              }}
                            >
                              {pages.map((page, index) => (
                                <ColorButton
                                  key={index}
                                  sx={{ my: 2, display: "block" }}
                                  className={
                                    value === index
                                      ? homeStyles.active +
                                        " " +
                                        homeStyles.menuItems
                                      : homeStyles.menuItems
                                  }
                                  onClick={(e) => {
                                    page.subMenu
                                      ? handleClick(index, e)
                                      : handleMenuClick(index);
                                  }}
                                >
                                  {page.label}
                                  {page.subMenu && (
                                    <StyledMenu
                                      anchorEl={!!anchorEl && anchorEl[index]}
                                      open={
                                        !!anchorEl && Boolean(anchorEl[index])
                                      }
                                      onClose={handleClose}
                                      onBlur={handleClose}
                                    >
                                      {page.subMenu.map((item, index) => (
                                        <MenuItem
                                          key={index}
                                          onClick={() =>
                                            window.open(item.url, "_blank")
                                          }
                                        >
                                          {item.label}
                                        </MenuItem>
                                      ))}
                                    </StyledMenu>
                                  )}
                                </ColorButton>
                              ))}
                            </Box>
                          </Toolbar>
                        </Container>
                      </AppBar>

                      {/* banner */}
                      <div className={homeStyles.banner} ref={homeRef}>
                        <Container maxWidth="xl">
                          <Grid container>
                            <Grid item md={5}>
                              {banner.map((item, index) => (
                                <Box key={index}>
                                  <Typography
                                    variant="h2"
                                    className={homeStyles.bannerTitle}
                                    dangerouslySetInnerHTML={{
                                      __html: item.title
                                    }}
                                  />
                                  <Typography
                                    className={homeStyles.bannerParagraph}
                                  >
                                    {item.paragraph}
                                  </Typography>
                                  <ColorButton
                                    variant="contained"
                                    className={homeStyles.button}
                                    onClick={() =>
                                      handleMenuClick(MENU_ITEMS.CONTACT_US)
                                    }
                                  >
                                    Explore
                                  </ColorButton>
                                  <Typography
                                    variant="h3"
                                    dangerouslySetInnerHTML={{
                                      __html: item.subTitle
                                    }}
                                  />
                                  {item.content.map((text, index) => (
                                    <Typography
                                      key={index}
                                      dangerouslySetInnerHTML={{ __html: text }}
                                    />
                                  ))}
                                </Box>
                              ))}
                            </Grid>
                          </Grid>
                        </Container>
                      </div>
                      {/* <div className={classes.banner} ref={homeRef}>
                        <div
                          className={
                            props.width === "xs" || props.width === "sm"
                              ? classes.newLandingPageContentMob
                              : classes.newLandingPageContent
                          }
                        >
                          <h1>Your Cloud. Simplified.</h1>
                          <p>
                            You don't have to know the cloud to use the cloud.
                          </p>
                          <div>
                            <button
                              className={
                                props.width === "xs" || props.width === "sm"
                                  ? classes.newLandingPageContentButtonMob
                                  : classes.newLandingPageContentButton
                              }
                              onClick={() =>
                                handleMenuClick(MENU_ITEMS.CONTACT_US)
                              }
                            >
                              Action
                            </button>
                          </div>
                        </div>
                      </div> */}
                      {/* What is ManageX */}
                      {/* <div className={classes.whatsManageX}>
                        <Container maxWidth="xl">
                          <Grid
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Grid item md={6}>
                              <h3>What is ManageX?</h3>
                              <p>
                                ManageX is a{" "}
                                <span>
                                  cloud infrastructure abstraction layer
                                </span>{" "}
                                that empowers non-IT aligned researchers, staff,
                                employees, and students with direct access to
                                limitless computing resources at a global scale.
                              </p>
                              <p>
                                ManageX enables
                                <span>
                                  {" "}
                                  simpler, more intuitive cloud utilization
                                  scenarios{" "}
                                </span>
                                with collaboration supported across legacy
                                databases, application run time environments,
                                and large-scale compute clusters...all through
                                an intuitive, productive experience.
                              </p>
                            </Grid>
                            <Grid item md={4}>
                              <img
                                src={cloudComputing}
                                alt="title"
                                className={classes.cloudImage}
                              />
                            </Grid>
                          </Grid>
                        </Container>
                      </div> */}
                      {/* Difference */}
                      <div
                        id="content1"
                        ref={WhysUsRef}
                        className={homeStyles.differences}
                      >
                        <Container maxWidth="xl">
                          <Grid
                            container
                            direction="column"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Grid item xs={12}>
                              <div className={homeStyles.titleMain}>
                                <h2>
                                  The <span>ManageX</span> Difference
                                </h2>
                                {/* <h3 className={homeStyles.subTitle}>
                                  ManageX empowers you with
                                </h3> */}
                              </div>
                            </Grid>
                            <Grid item xs={12}>
                              <Grid container spacing={2}>
                                {whyUs.map((data, index) => {
                                  return (
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      lg={4}
                                      key={index}
                                    >
                                      <div className={homeStyles.differenceBox}>
                                        <img
                                          src={data.image}
                                          alt={data.highlight}
                                        />
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html: data.content
                                          }}
                                        />
                                      </div>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Container>
                      </div>
                      {/* Solution Offerings */}
                      <div ref={SolutionsRef} className={homeStyles.solutions}>
                        <Container maxWidth="xl">
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <div className={homeStyles.titleMain}>
                                <h2>Solutions</h2>
                              </div>
                            </Grid>
                            {solution.map((item, index) => (
                              <Grid item md={4} key={index}>
                                <div className={homeStyles.solutionBlock}>
                                  <img
                                    src={LandingPageLogo}
                                    alt="manageX logo"
                                    className={homeStyles.logo}
                                  />
                                  <h3 className={homeStyles.solutionTitle}>
                                    {item.title}
                                  </h3>
                                  <p>{item.paragraph}</p>
                                  <Button
                                    variant="outlined"
                                    className={homeStyles.button}
                                    onClick={() =>
                                      window.open(item.url, "_blank")
                                    }
                                  >
                                    Learn More
                                  </Button>
                                  {/* <img
                                    src={item.image}
                                    alt={item.title}
                                    className={homeStyles.solutionImage}
                                  />
                                  <div className={homeStyles.solutionTitle}>
                                    <p>{item.resource}</p>
                                    <h3>{item.title}</h3>
                                  </div>
                                  <div className={homeStyles.dividerSolution} />
                                  <p>{item.paragraph}</p>
                                  <img
                                    src={arrowCircle}
                                    alt="arrow Right"
                                    className={homeStyles.solutionArrow}
                                    onClick={() =>
                                      window.open(item.url, "_blank")
                                    }
                                  /> */}
                                </div>
                              </Grid>
                            ))}
                          </Grid>
                        </Container>
                      </div>
                      {/* Competencies */}
                      <div className={homeStyles.competencies}>
                        <Container maxWidth="xl">
                          <Grid container spacing={4}>
                            <Grid item xs={12}>
                              <div className={homeStyles.titleMain}>
                                <h2>
                                  <span>Three ways</span> we help you achieve
                                  your objectives:
                                </h2>
                              </div>
                            </Grid>
                            {competencies.map((item, index) => (
                              <Grid key={index} item xs={12} md={4}>
                                <Box
                                  className={homeStyles.competenciesBlock}
                                  key={index}
                                >
                                  <h4
                                    className={
                                      index === 0
                                        ? homeStyles.titleColor1
                                        : index === 2
                                        ? homeStyles.titleColor2
                                        : ""
                                    }
                                  >
                                    {item.title}
                                  </h4>
                                  <p>{item.desc}</p>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                        </Container>
                      </div>
                      {/* Capabilities */}
                      <div
                        ref={capabilitiesRef}
                        className={homeStyles.capabilitiesMain}
                      >
                        <Container maxWidth="xl">
                          <Grid container>
                            <Grid item xs={12}>
                              <div className={homeStyles.titleMain}>
                                <h2>Capabilities</h2>
                                <h3 className={homeStyles.subTitle}>
                                  Comprehensive, end-to-end security and
                                  compliance protocols available for Public
                                  Clouds, Private Clouds, Hybrid Clouds and
                                  Edge/IoT
                                </h3>
                              </div>
                            </Grid>
                            <Grid item xs={12}>
                              <Grid container spacing={6}>
                                {capabilities.map((cap, index) => {
                                  return (
                                    <Grid item xs={12} md={6} key={index}>
                                      <div
                                        className={homeStyles.capabilitiesBox}
                                      >
                                        <img src={cap.image} alt={cap.title} />
                                        <div>
                                          <h4>{cap.title}</h4>
                                          <p>{cap.tag}</p>
                                        </div>
                                      </div>
                                    </Grid>
                                  );
                                })}
                                {/* {resources.map((resource, index) => {
                                  return (
                                    <Grid item xs={6} md={3} key={index}>
                                      <Box
                                        className={
                                          homeStyles.resourcesIconBlock
                                        }
                                      >
                                        <img
                                          src={resource.image}
                                          alt="private cloud"
                                        />
                                        <h5>{resource.title}</h5>
                                      </Box>
                                    </Grid>
                                  );
                                })} */}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Container>
                      </div>
                      {/* drop message */}
                      <div
                        className={generalStyles.contactForm}
                        ref={contactRef}
                      >
                        <div
                          className={
                            props.width === "xs" || props.width === "sm"
                              ? classes.formContentMob
                              : classes.formContent
                          }
                        >
                          <Container maxWidth="xl">
                            <Grid container>
                              <Grid className={generalStyles.dropMessageContainer} item xs={12}>
                                <Box className={generalStyles.formTitle}>
                                  <div className={generalStyles.titleLine}>
                                    <h2>Drop a Message</h2>
                                  </div>
                                  <h3>Get in touch</h3>
                                  <p>
                                    Send us a mail and get in touch with us to
                                    clear any queries you have. Please provide
                                    the reason for a trail access if you need
                                    one.
                                  </p>
                                  <p>We will get in touch with you</p>
                                </Box>
                                <form>
                                  {/* <input
                              required
                              type="text"
                              id="name"
                              name="name"
                              placeholder="Name"
                            /> */}
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                      <input
                                        required
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        placeholder="First name"
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <input
                                        required
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        placeholder="Last name"
                                      />
                                    </Grid>
                                    <Grid item xs={12}>
                                      <input
                                        required
                                        type="text"
                                        id="email"
                                        name="email"
                                        placeholder="Email"
                                        pattern="/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g"
                                      />
                                    </Grid>
                                    <Grid item xs={12}>
                                      <textarea
                                        required
                                        id="message"
                                        name="message"
                                        placeholder="Message"
                                        rows="10"
                                      />
                                    </Grid>
                                    <Grid
                                      className={generalStyles.btnContainer}
                                      item
                                      xs={12}
                                      alignItems={"center"}
                                      justifyContent={"center"}
                                    >
                                      <input
                                        type="submit"
                                        value="Request Now"
                                        className={generalStyles.buttonBlue}
                                        onClick={(event) => {
                                          let message =
                                            document.getElementById(
                                              "message"
                                            ).value;
                                          let firstName =
                                            document.getElementById(
                                              "firstName"
                                            ).value;
                                          let lastName =
                                            document.getElementById(
                                              "lastName"
                                            ).value;
                                          let email =
                                            document.getElementById(
                                              "email"
                                            ).value;
                                          if (
                                            message &&
                                            firstName &&
                                            lastName &&
                                            email
                                          ) {
                                            if (
                                              /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
                                                email
                                              )
                                            ) {
                                              document.getElementById(
                                                "formResult"
                                              ).innerHTML =
                                                "Request Precessing...";
                                              let reqData = {
                                                name:
                                                  firstName + " " + lastName,
                                                mail: email,
                                                message: message
                                              };
                                              fetch("/api/drop/message", {
                                                method: "POST",
                                                headers: {
                                                  "Content-Type":
                                                    "application/json"
                                                },
                                                body: JSON.stringify(reqData)
                                              })
                                                .then((response) =>
                                                  response.json()
                                                )
                                                .then((data) => {
                                                  document.getElementById(
                                                    "formResult"
                                                  ).innerHTML =
                                                    "<span style='color: green;'>** Request send successfully **</span>";
                                                })
                                                .catch((error) => {
                                                  document.getElementById(
                                                    "formResult"
                                                  ).innerHTML =
                                                    "<span style='color: red;'>** Request failed **</span>";
                                                });
                                              event.preventDefault();
                                            } else {
                                              document.getElementById(
                                                "formResult"
                                              ).innerHTML =
                                                "<span style='color: red;'>** Please enter valid mail **</span>";
                                              event.preventDefault();
                                            }
                                          } else {
                                            document.getElementById(
                                              "formResult"
                                            ).innerHTML =
                                              "<span style='color: red;'>** Please fill the form **</span>";
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                      <p id="formResult"></p>
                                    </Grid>
                                  </Grid>
                                </form>
                              </Grid>
                            </Grid>
                          </Container>
                        </div>
                      </div>
                      <div className={generalStyles.copyRight}>
                        <Container maxWidth="xl">
                          <Grid container>
                            <Grid item xs={  props.width === "xs" || props.width === "sm" ? 12 : 6}>
                              <CopyRightContainer>
                              © {year}{" "}
                              <a
                                href={"https://terawe.com"}
                                style={{ textDecoration: "none" }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Terawe Corp.
                              </a>{" "}
                              All Rights Reserved.{" "}
                              </CopyRightContainer>
                              {/* <span className={classes.separator}>|</span>{" "} */}
                              <CopyRightContainer>
                              <a
                                href={"https://terawe.com"}
                                style={{ textDecoration: "none" }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                www.terawe.com
                              </a>{" "}
                              <span className={classes.separator}>|</span>{" "}
                              <a
                                href={`mailto:research@terawe.com`}
                                style={{ textDecoration: "none" }}
                              >
                                research@terawe.com
                              </a>
                              </CopyRightContainer>
                            </Grid>
                            <Grid item xs={props.width === "xs" || props.width === "sm" ? 12 : 6} className={generalStyles.links}>
                              <a
                                href={"https://terawe.com/Terms-Of-Use"}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Terms of use
                              </a>{" "}
                              <span className={classes.separator}>|</span>{" "}
                              <a
                                href={"https://terawe.com/Privacy-Policy"}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Privacy Policy
                              </a>
                            </Grid>
                          </Grid>
                        </Container>
                        {/* <div>
                          <div className={classes.footerLeft}>
                            <p>
                              © {year}{" "}
                              <a
                                href={"https://terawe.com"}
                                style={{ textDecoration: "none" }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Terawe Corp.
                              </a>{" "}
                              All Rights Reserved.{" "}
                              <span className={classes.separator}>|</span>{" "}
                              <a
                                href={"https://terawe.com"}
                                style={{ textDecoration: "none" }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                www.terawe.com
                              </a>{" "}
                              <span className={classes.separator}>|</span>{" "}
                              <a
                                href={`mailto:research@terawe.com`}
                                style={{ textDecoration: "none" }}
                              >
                                research@terawe.com
                              </a>
                            </p>
                          </div>
                          <div
                            className={classes.footerRight}
                            style={{
                              paddingRight: 50,
                              justifyContent: "center"
                            }}
                          >
                            <p>
                              <a
                                href={"https://terawe.com/Terms-Of-Use"}
                                style={{ textDecoration: "none" }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Terms of use
                              </a>{" "}
                              <span className={classes.separator}>|</span>{" "}
                              <a
                                href={"https://terawe.com/Privacy-Policy"}
                                style={{ textDecoration: "none" }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Privacy Policy
                              </a>
                            </p>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  );
                case "/research":
                  return <Research props={props} />;
                case "/hpc/i":
                  return <HPCComponent props={props} />;
                default:
                  return (
                    <div
                      style={{
                        overflowX: "hidden",
                        backgroundColor: "#273041"
                      }}
                      ref={homeRef}
                    >
                      <CssBaseline />
                      <main
                        className={classes.layout}
                        style={{ overflowXY: "hidden" }}
                      >
                        <Headline
                          selectTab={selectTab}
                          setShowRequestTrialMessage={
                            setShowRequestTrialMessage
                          }
                          handleMenuClick={handleMenuClick}
                          classes={classes}
                          setSignInClick={setSignInClick}
                          auth={auth}
                          AuthState={AuthState}
                          onSignIn={() => dispatch(AuthActions.login(auth))}
                          pathUrl={pathUrl}
                          setPathUrl={setPathUrl}
                        />
                        <Content
                          requestTrialLoading={requestTrialLoading}
                          setShowRequestTrialMessage={
                            setShowRequestTrialMessage
                          }
                          loginRequestStatus={loginRequestStatus}
                          pathUrl={pathUrl}
                          setPathUrl={setPathUrl}
                          loginErrorMessage={loginErrorMessage}
                          RequestTrialAccess={RequestTrialAccess}
                          setRequestTrialData={setRequestTrialData}
                          requestTrialData={requestTrialData}
                          homeRef={homeRef}
                          offerRef={offerRef}
                          requestTrial={requestTrial}
                          benefit={benefitRef}
                          eliminateRef={eliminateRef}
                          handleMenuClick={handleMenuClick}
                          showRequestTrailMessage={showRequestTrailMessage}
                          setEmailError={setEmailError}
                          resourceRef={resourceRef}
                          classes={classes}
                          auth={auth}
                          setDisableError={setDisableError}
                          disableError={disableError}
                          emailError={emailError}
                          setContactError={setContactError}
                          error={error}
                          contactError={contactError}
                          setContactErrorMessage={setContactErrorMessage}
                          contactErrorMessage={contactErrorMessage}
                          channelResource={channelResource}
                        />
                      </main>
                    </div>
                  );
              }
            })()}
          </>
        )
      ) : (
        <Redirect
          to={
            auth.provider === "aws-auth"
              ? `/portal/aws/s3bucket`
              : !auth.account.roleInfo && !auth.account.roleInfo.landingPage
              ? `/portal`
              : "/portal" +
                (!!auth.account.roleInfo.landingPage
                  ? auth.account.roleInfo.landingPage
                  : auth.account.orgInfo.landingPage)
          }
        />
      )}
    </React.Fragment>
  );
}

export default withWidth()(ManageX);
